// Configuración central

// ✅ Toggle principal (para usar offline)
// En Vue CLI, las env vars deben iniciar con VUE_APP_
// Ejemplo: VUE_APP_ACCESS_VALIDATION_ENABLED=false
export const ACCESS_VALIDATION_ENABLED = String(
  process.env.VUE_APP_ACCESS_VALIDATION_ENABLED ?? 'true'
).toLowerCase() !== 'false';

// ✅ Misma validación que tu proyecto actual
export const AUTH_LS_KEY = 'hpAuth';
export const AUTH_URL = 'https://flow.gestiontotal.app/webhook/elements/verificacion-pin';
export const AUTH_TOKEN = 'f9129d9408789e67ad79f34a1106e756';
export const AUTH_TTL_DAYS = 21;

// ✅ Impresión final
export const PRINT_WIDTH_MM = 50;
export const PRINT_HEIGHT_MM = 90;
export const PRINT_DPI = 313;

// Cálculo px a partir de mm y DPI
export const OUTPUT_WIDTH_PX = Math.round((PRINT_WIDTH_MM / 25.4) * PRINT_DPI);  // 616
export const OUTPUT_HEIGHT_PX = Math.round((PRINT_HEIGHT_MM / 25.4) * PRINT_DPI); // 1109
export const OUTPUT_ASPECT = OUTPUT_WIDTH_PX / OUTPUT_HEIGHT_PX; // ~0.5555

// Cámara
export const DEFAULT_FACING_MODE = 'user'; // 'user' o 'environment'
export const MIRROR_PREVIEW = true;
export const MIRROR_CAPTURE = true;

// Endpoint de registro (no bloquea el flujo si falla)
export const API_GUARDAR_PATH = '/api/guardar';
